<div id="joint-invitation-success-dialog">
  <div mat-dialog-title>
    You're all set
  </div>
  <br>
  <div mat-dialog-content>
    <div class="center">
      <img src="assets/images/bask/congratulations-icon.svg" alt="Successful joint invitation created">
    </div>
    <br>
    <br>
    <p>We have emailed a link to the joint owner.</p>
    <p>This invitation is valid until <span id="expiryDate">{{expiryDate | date:'longDate'}}</span>.</p>
  </div>
</div>
